import Events from '@/resources/events';
import PaginatedList from './mixins/paginated-list';

export default {
  namespaced: true,
  ...PaginatedList(Events, {}, 'events')
};
